import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class GetInvoicesArgs {
  @Field(t => Int, { nullable: true })
  forUserId?: number

  @Field(t => Int, { nullable: true })
  limit?: number

  @Field({ nullable: true })
  startingAfter?: string
}
